import Button from '../button/Button';
import { useAlertStore } from 'src/ui/common/alert/AlertStore';
import WF_4_7_1_AlertHistory from '../../desktop/alertHistory/WF_4_7_1_AlertHistory';
import { useTranslation } from 'react-i18next';

function WF_HistoryMenu() {
  const { t } = useTranslation();
  const { showAlert } = useAlertStore();
  const handleShowHistoryList = () => {
    showAlert({ content: <WF_4_7_1_AlertHistory /> });
  };

  return (
    <div className="mt-4 rounded-lg border border-yellow-400 bg-yellow-100 p-4">
      <div className="mb-2 text-lg font-bold">{t('wf.menu.historyMenuTitle')}</div>
      <Button title={t('wf.menu.historyList')} onClick={handleShowHistoryList} />
    </div>
  );
}

export default WF_HistoryMenu;
